var map = {
	"./1.png": 57390,
	"./10.png": 32557,
	"./2.png": 32295,
	"./3.png": 92039,
	"./4.png": 31129,
	"./5.png": 80767,
	"./6.png": 92527,
	"./7.png": 71812,
	"./8.png": 83118,
	"./9.png": 82641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45310;